
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';
import moment from 'moment';
import { Quotation, QuotationProperty, Task } from '@/types';
import QuotationObject from '@/components/QuotationObject.vue';

moment.locale('it');

@Component({
  components: {
    QuotationObject,
  },
})
export default class QuotationsList extends Vue {
  @Prop(Object) readonly task!: Task;

  @Prop(String) readonly title!: string;

  get lead() {
    return this.$store.getters.currentLead;
  }

  get quotations() {
    return this.lead && Array.isArray(this.lead.Quotations) && this.lead.Quotations.length > 0
      ? this.lead.Quotations
      : [];
  }

  get hasQuotations() {
    return this.quotations.length > 0;
  }

  get visibleQuotations() {
    return this.quotations.filter((q: Quotation, index: number) => this.task.status !== 'completed' || q.complete || index === 0);
  }

  get editable() {
    return this.task && 'status' in this.task && this.task.status === null;
  }

  hasPartialData(quotation: Quotation) {
    const original = JSON.parse(quotation.original);

    return 'quotation' in original && 'partialData' in original.quotation;
  }

  originalQuotation(quotation: Quotation, attr: QuotationProperty = null) {
    const original = quotation && 'original' in quotation && quotation.original
      ? JSON.parse(quotation.original)
      : null;

    if (!attr) {
      return original && 'quotation' in original && original.quotation
        ? original.quotation
        : null;
    }

    switch (attr) {
      case 'fabbisognoAnnuo':
        return new Intl.NumberFormat('it-IT').format(original.quotation.fabbisognoAnnuo);
      case 'potenzaDaConsumi':
        return new Intl.NumberFormat(
          'it-IT',
          { maximumFractionDigits: 2, minimumFractionDigits: 2 },
        ).format(original.quotation.partialData.potenzaDaConsumi);
      case 'potenzaDaSpazioPerformance':
        return new Intl.NumberFormat(
          'it-IT',
          { maximumFractionDigits: 2, minimumFractionDigits: 2 },
        ).format(original.quotation.partialData.potenzaDaSpazio.performance);
      case 'potenzaDaSpazioTop':
        return new Intl.NumberFormat(
          'it-IT',
          { maximumFractionDigits: 2, minimumFractionDigits: 2 },
        ).format(original.quotation.partialData.potenzaDaSpazio.top);
      case 'producibilitaAnnuaPerformance':
        return new Intl.NumberFormat(
          'it-IT',
          { maximumFractionDigits: 0 },
        ).format(original.quotation.partialData.producibilitaAnnua.performance);
      case 'producibilitaAnnuaTop':
        return new Intl.NumberFormat(
          'it-IT',
          { maximumFractionDigits: 0 },
        ).format(original.quotation.partialData.producibilitaAnnua.top);
      case 'faldePerformance':
        return original.quotation.partialData.numeroPannelliInstallabili
          .map((type: any) => type.performance);
      case 'faldeTop':
        return original.quotation.partialData.numeroPannelliInstallabili
          .map((type: any) => type.top);
      default:
        return null;
    }
  }

  mDateTime(date: Date) {
    return `${moment(date).format('L')} ore ${moment(date).format('LT')}`;
  }
}
